/*
 *
 * NewsHomePopups
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 19-Mar-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  confirm: <PortalMessage
    id='t.app.findOutMore'
    defaultMessage='Scopri di più'
           />,
  acknowledge: <PortalMessage
    id='t.app.okUnderstood'
    defaultMessage='Ok, ho capito'
               />,
  installTerminal: <PortalMessage
    id='t.app.terminalActivation.installTerminal'
    defaultMessage='Installa terminale'
                   />,
  goToCompanyData: <PortalMessage
    id='t.app.aml.goToSocietyData'
    defaultMessage='vai a dati società'
                   />
}

export default formattedMessage
